import React from 'react';
import { SIMPLIFIED_FIRST_VISIT } from 'config/app.config';
import { TourBadgeMoment } from 'firstVisit/web/TourPieces';
import BadgeMomentToday from './BadgeMoment.js';

/**
 * Web: a badge earned is the owner's prototype moment (rays, the badge, its QuikCoins, then Collect - outlined with the
 * hand - and it flies into the Collection Store; owner rounds 6-13, Sol proto-port P1 A) where the simplified first
 * visit is switched on (DEV); elsewhere today's moment (BadgeMoment.js).
 */
export default function BadgeMoment({ badge, onDone }) {
  if (!SIMPLIFIED_FIRST_VISIT) return <BadgeMomentToday badge={badge} onDone={onDone} />;
  if (!badge) return null;
  return <TourBadgeMoment key={badge.badgeId || badge.name} badge={badge} onDone={onDone} />;
}
